/* Self Love Spot: SLS21 (21%) also applies hidden free-shipping code SLS21SHIP. */
(function () {
  var PCT = "SLS21";
  var SHIP = "SLS21SHIP";

  function cartRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    root = String(root);
    if (root.slice(-1) !== "/") root += "/";
    return root;
  }

  function codeOf(row) {
    if (!row) return "";
    if (typeof row === "string") return row.trim();
    return String(row.code || row.discount_code || row.title || "").trim();
  }

  function hasCode(list, code) {
    var want = code.toUpperCase();
    for (var i = 0; i < list.length; i++) {
      if (list[i].toUpperCase() === want) return true;
    }
    return false;
  }

  function codesFromCart(cart) {
    var out = [];
    var list = (cart && cart.discount_codes) || [];
    for (var i = 0; i < list.length; i++) {
      var code = codeOf(list[i]);
      if (code) out.push(code);
    }
    return out;
  }

  function pairIfNeeded() {
    return fetch(cartRoot() + "cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var have = codesFromCart(cart);
        if (!hasCode(have, PCT) || hasCode(have, SHIP)) return;
        have.push(SHIP);
        return fetch(cartRoot() + "cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify({ discount: have.join(",") })
        });
      })
      .catch(function () {});
  }

  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!form || !form.querySelector) return;
      var input = form.querySelector('input[name="discount"]');
      if (!input) return;
      var parts = String(input.value || "")
        .split(",")
        .map(function (s) { return s.trim(); })
        .filter(Boolean);
      if (!hasCode(parts, PCT) || hasCode(parts, SHIP)) return;
      parts.push(SHIP);
      input.value = parts.join(",");
    },
    true
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", pairIfNeeded);
  } else {
    pairIfNeeded();
  }
})();
